///<reference path="BaseScreen.ts"/>
namespace nscs.screen {

    export class ChooseCharacterScreen extends BaseScreen {

        private locked_image:Phaser.GameObjects.Image;
        private locked_label:Phaser.GameObjects.Text;

        constructor(scene:Phaser.Scene) {
            super(scene);

            let bg = new Phaser.GameObjects.Graphics(this.scene);
            bg.setPosition(0, 0);
            bg.fillStyle(0x36ACBE, 1);
            bg.fillRect(0, 0, game.scale.width, game.scale.height);
            this.add(bg);

            this.add(new Phaser.GameObjects.Image(this.scene, 54-10, 91-15, 'ui-atlas', 'circ'+'0000').setOrigin(0, 0));
            this.add(new Phaser.GameObjects.Image(this.scene, 175-10, 129-15, 'ui-atlas', 'circ'+'0000').setOrigin(0, 0));
            this.add(new Phaser.GameObjects.Image(this.scene, 299-10, 91-15, 'ui-atlas', 'circ'+'0000').setOrigin(0, 0));

            let positions:object[] = [
                {x:54-3,y:91-15},{x:175-3,y:129-15},{x:299-3,y:91-15}
            ];
            let i:number = 0;
            for (let p of positions) {
                let btn = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'ui-atlas', 'nugget_btn'+'0000').setOrigin(0, 0);
                this.add(btn);
                let character:string = nscs.gameplay.Gameplay.characters[i];
                i++;
                btn.setInteractive({cursor: 'pointer'});
                btn.on('pointerup', () => {
                    if (nscs.gameplay.Gameplay.isPamLocked && character == "pam") return;
                    btn.setFrame('nugget_btn'+'0000');
                    // nscs.sound.SoundManager.getInstance().playSound('winnerSND');

                    nscs.scene.MainScene.instance.gameplay.character = character;
                    nscs.scene.MainScene.instance.playGame();

                    if (character == 'nugget') {
                        sendEvent(petaGA_GameCategory_Game, 'Character Selection', 'New Super Chick Sisters - Character Nugget');
                    } else if (character == 'chickette') {
                        sendEvent(petaGA_GameCategory_Game, 'Character Selection', 'New Super Chick Sisters - Character Chickette');
                    }
                });
                btn.on('pointerover', () => {
                    nscs.sound.SoundManager.getInstance().playSound('whistleSND', 2);
                    btn.setFrame('nugget_btn'+'0001');
                });
                btn.on('pointerout', () => {
                    btn.setFrame('nugget_btn'+'0000');
                });
            }

            this.add(new Phaser.GameObjects.Image(this.scene, 54-10+75, 91-15+55, 'ui-atlas', 'ANI_Nugget_wholeMC'+'0000').setOrigin(0.5, 0.5).setScale(-1, 1));
            this.add(new Phaser.GameObjects.Image(this.scene, 175-10+80, 129-15+35, 'ui-atlas', 'ANI_Chickette_wholeMC'+'0000').setOrigin(0.5, 0.5).setScale(-1, 1));
            this.add(new Phaser.GameObjects.Image(this.scene, 175+200, 129-25, 'ui-atlas', 'pam_sel'+'0000').setOrigin(0.5, 0.5).setScale(-1, 1));

            this.locked_image = new Phaser.GameObjects.Image(this.scene, 165+200, 150, 'ui-atlas', 'pamlocked_btn'+'0000').setOrigin(0.5, 0.5);
            this.add(this.locked_image);
            this.locked_label = this.scene.add.text(162+200, 160, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 24,
                "color": "#006699",
                "align": 'left'
            });
            this.locked_label.angle = -15;
            this.locked_label.setOrigin(0.5, 0.5);
            this.add(this.locked_label);
            nscs.gameplay.Gameplay.setText(this.locked_label, 'Locked');

            this.add(MainMenuScreen.createEye(120, 120, this.scene));
            this.add(MainMenuScreen.createEye(150, 117, this.scene));
            this.add(MainMenuScreen.createEye(240, 133, this.scene, 2000));
            this.add(MainMenuScreen.createEye(270, 130, this.scene, 2000));

            let pam_mc_eye = scene.add.sprite(358, 80, 'ui-atlas');
            let pam_mc_eye_anim:string = 'pam_mc_eye_anim';
            if (!scene.anims.exists(pam_mc_eye_anim)) {
                scene.anims.create({
                    key: pam_mc_eye_anim,
                    frames: scene.anims.generateFrameNames('ui-atlas', {
                        start: 0, end: 337, zeroPad: 4,
                        prefix: 'pam_mc_eye', suffix: ''
                    }),
                    frameRate: 60,
                    repeat: -1
                });
            }
            pam_mc_eye.play(pam_mc_eye_anim);
            pam_mc_eye.setScale(-1, 1);
            this.add(pam_mc_eye);

            let character0_label:Phaser.GameObjects.Text = this.scene.add.text(54-10+65, 91-15+170, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 14,
                "color": "#FFFFFF",
                "align": 'left'
            });
            character0_label.setOrigin(0.5, 0.5);
            this.add(character0_label);
            nscs.gameplay.Gameplay.setText(character0_label, 'Nugget');

            let character1_label:Phaser.GameObjects.Text = this.scene.add.text(175-10+65, 129-15+170, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 14,
                "color": "#FFFFFF",
                "align": 'left'
            });
            character1_label.setOrigin(0.5, 0.5);
            this.add(character1_label);
            nscs.gameplay.Gameplay.setText(character1_label, 'Chickette');

            let character2_label:Phaser.GameObjects.Text = this.scene.add.text(299-10+80, 91-15+175, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 14,
                "color": "#FFFFFF",
                "align": 'center'
            });
            character2_label.setOrigin(0.5, 0.5);
            character2_label.setWordWrapWidth(100);
            this.add(character2_label);
            nscs.gameplay.Gameplay.setText(character2_label, 'PamLong');

            let ChooseChar3_label:Phaser.GameObjects.Text = this.scene.add.text(30, 30, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 18,
                "color": "#FFFFFF",
                "align": 'left'
            });
            ChooseChar3_label.setOrigin(0, 0.5);
            this.add(ChooseChar3_label);
            nscs.gameplay.Gameplay.setText(ChooseChar3_label, 'ChooseChar');

            this.setPamLocked(nscs.gameplay.Gameplay.isPamLocked);
        }

        public setPamLocked(locked:boolean):void {
            this.locked_image.visible = this.locked_label.visible = locked;
        }

        public updateScreen(): void {
            super.updateScreen();

            if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                nscs.scene.MainScene.instance.inputController.escPressUsed();
                nscs.scene.MainScene.instance.switchScreen(new nscs.screen.KidFriendlyScreen(this.scene));
            }
        }
    }
}